import {httpClient} from './';

export const _getMigrationImages = (class_id, filter_type = 1) => {
  return httpClient.post(`class_admin/migration_data/cleaning`,
      {
        class_id,
        filter_type
      }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
export const _dateMarkDelete = (img_uuid_list, class_id) => {
  return httpClient.post(`data_mark/batch/delete`,
      {
        img_uuid_list,
        class_id
      }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data);
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`));
    }
  });
};
